<!--
  The headset button in the header icon row - opens the support thread (SupportModal, mounted once
  in App.vue). Mounted twice like the whatsapp box beside it: the desktop row and the mobile row,
  CSS hides one. The unread count lives in the store (the modal keeps it), so both instances agree.
-->
<template>

    <li class="headerSupportButton"
        title="תמיכה"
        :style="mobile ? 'list-style-type:none;padding:12px;font-size:20px;position:relative;top:-2px;' : 'position:relative;'"
        @click="$root.$emit('openSupportModal')">

        <span class="headerSupportIcon">

            <i class="fa-solid fa-headset"
               :style="mobile ? 'position:relative;top:2px;' : 'position:relative;top:3px;'"></i>

            <!-- the little question bubble of the reference icon -->
            <span class="headerSupportQuestion">?</span>

        </span>

        <span v-if="$store.state.supportUnread > 0"
              class="notification-badge">{{ $store.state.supportUnread }}</span>

    </li>

</template>
<script>

export default {

    name: 'HeaderSupportButton',

    props: ['mobile'],

}

</script>
<style>
.headerSupportButton {
    cursor: pointer;
    user-select: none;
}

.headerSupportIcon {
    position: relative;
    display: inline-block;
}

.headerSupportQuestion {
    position: absolute;
    bottom: -3px;
    left: -7px;
    width: 14px;
    height: 14px;
    line-height: 14px;
    border-radius: 100%;
    background: #ab8ce4;
    color: white;
    font-size: 9px;
    font-weight: 700;
    text-align: center;
    font-family: Arial, sans-serif;
    box-shadow: 0 0 0 2px white;
    pointer-events: none;
}
</style>
